// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/$location._c.location/GoogleMapLocationIdComponent.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$(),
  _s2 = $RefreshSig$(),
  _s3 = $RefreshSig$(),
  _s4 = $RefreshSig$(),
  _s5 = $RefreshSig$(),
  _s6 = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/$location._c.location/GoogleMapLocationIdComponent.tsx");
}
// REMIX HMR END

import { Loader } from '@googlemaps/js-api-loader';
import { useCallback, useDeferredValue, useEffect, useRef, useState } from 'react';
import invariant from 'tiny-invariant';
import { ScrollView } from '~/components/ScrollView';
import { useDialog } from '~/components/useDialog';
import cn from './GoogleMapLocationIdComponent.module.css';
import pinSvg from './pin.svg';
export function GoogleMapPlaceIdComponent({
  placeId,
  language,
  apiKey,
  onSelect
}) {
  _s();
  const {
    open,
    close,
    Dialog
  } = useDialog();
  const handleSelect = useCallback(placeId => {
    onSelect(placeId);
    close();
  }, [close, onSelect]);
  return <>
      <button onClick={open}>edit</button>
      <p>
        <input value={placeId ?? ''} readOnly />
      </p>
      <Dialog className={cn.Dialog}>
        <GoogleMapPlaceIdComponentDialogContent placeId={placeId ?? ''} language={language} apiKey={apiKey} onClose={close} onSelect={handleSelect} />

      </Dialog>
    </>;
}
_s(GoogleMapPlaceIdComponent, "qsb5IlwKE7M7WyIkoihlbH54UPQ=", false, function () {
  return [useDialog];
});
_c = GoogleMapPlaceIdComponent;
function GoogleMapPlaceIdComponentDialogContent({
  placeId,
  language,
  apiKey,
  onClose,
  onSelect
}) {
  _s2();
  const [tmpPlaceId, setTmpPlaceId] = useState(placeId);
  const handleSelect = useCallback(() => {
    onSelect(tmpPlaceId);
  }, [onSelect, tmpPlaceId]);
  return <section className={cn.DialogContent}>
      <header>
        <button onClick={onClose}>close</button>
        <h1>Google Map Place ID</h1>
      </header>
      <main>
        <PlaceIdSelector placeId={tmpPlaceId} language={language} apiKey={apiKey} onSelect={v => setTmpPlaceId(v)} />

      </main>
      <footer>
        <button disabled={!tmpPlaceId} className="debug-block" onClick={handleSelect}>

          select
        </button>
      </footer>
    </section>;
}
_s2(GoogleMapPlaceIdComponentDialogContent, "1n+qFtQvM4DlwQ+ga3iY41qp3kY=");
_c2 = GoogleMapPlaceIdComponentDialogContent;
function usePlace(apiKey, placeId) {
  _s3();
  const [place, setPlace] = useState(null);
  useEffect(() => {
    if (!placeId) {
      return;
    }
    (async function () {
      const mapLoader = new Loader({
        apiKey,
        version: 'beta'
      });
      const {
        Place
      } = await mapLoader.importLibrary('places');
      const place = new Place({
        id: placeId
      });
      await place.fetchFields({
        fields: ['displayName', 'location', 'nationalPhoneNumber', 'openingHours', 'adrFormatAddress']
      });
      setPlace(place);
    })();
  }, [apiKey, placeId]);
  return place;
}
_s3(usePlace, "9NRjyPZWAQr0BTtyU0PQxFLY1EY=");
const useAutoComplete = (input = null, language, apiKey) => {
  _s4();
  const autoCompleteServiceRef = useRef(null);
  const [predictions, setPredictions] = useState(null);
  useEffect(() => {
    const loader = new Loader({
      apiKey,
      version: 'beta'
    });
    (async function () {
      const {
        AutocompleteService
      } = await loader.importLibrary('places');
      autoCompleteServiceRef.current = new AutocompleteService();
    })();
  }, [apiKey]);
  useEffect(() => {
    if (!autoCompleteServiceRef.current) {
      return;
    }
    if (!input) {
      setPredictions(null);
      return;
    }
    autoCompleteServiceRef.current.getPlacePredictions({
      input,
      language
    }, predictions => {
      setPredictions(predictions);
    });
  }, [input, language]);
  return predictions;
};
_s4(useAutoComplete, "XEgK5lLpDaGXSNmmB/HfAfeCqFM=");
function AutoComplete({
  input,
  language,
  apiKey,
  onSelect
}) {
  _s5();
  const predictions = useAutoComplete(input, language, apiKey);
  return <ScrollView className={cn.AutoComplete}>
      <ul>
        {predictions?.map(prediction => <li key={prediction.place_id}>
            <button onClick={() => onSelect(prediction.place_id)}>
              {prediction.description}
            </button>
          </li>)}
      </ul>
    </ScrollView>;
}
_s5(AutoComplete, "FrL9R19/4UfaneHAAf7rZIi6FTQ=", false, function () {
  return [useAutoComplete];
});
_c3 = AutoComplete;
function PlaceIdSelector({
  placeId,
  language,
  apiKey,
  onSelect
}) {
  _s6();
  const mapRef = useRef(null);
  const linkRef = useRef(null);
  const place = usePlace(apiKey, placeId);
  const [value, setValue] = useState('');
  const deferredQuery = useDeferredValue(value);
  const autoCompleteServiceRef = useRef(null);
  useEffect(() => {
    const loader = new Loader({
      apiKey,
      version: 'beta'
    });
    (async function () {
      const {
        AutocompleteService
      } = await loader.importLibrary('places');
      autoCompleteServiceRef.current = new AutocompleteService();
    })();
  }, [apiKey]);
  const handleChangeValue = useCallback(e => {
    setValue(e.target.value);
  }, []);
  useEffect(() => {
    let marker;
    const handler = () => {
      linkRef.current?.click();
    };
    const pinImg = document.createElement('img');
    pinImg.src = pinSvg;
    pinImg.width = 64;
    (async function () {
      const mapLoader = new Loader({
        apiKey,
        version: 'beta'
      });
      const {
        Map
      } = await mapLoader.importLibrary('maps');
      const {
        AdvancedMarkerElement
      } = await mapLoader.importLibrary('marker');
      invariant(mapRef.current, 'mapRef.current is required');
      const map = new Map(mapRef.current, {
        center: place?.location,
        zoom: 15,
        mapId: 'd7fc6fe82daad8a',
        controlSize: 24,
        disableDefaultUI: true,
        clickableIcons: false,
        fullscreenControl: true
      });
      marker = new AdvancedMarkerElement({
        map,
        position: place?.location,
        title: place?.displayName,
        content: pinImg
      });
      marker.addEventListener('gmp-click', handler);
    })();
    return () => {
      marker?.removeEventListener('gmp-click', handler);
    };
  }, [apiKey, place]);
  return <>
      <label>
        search
        <input value={value} onChange={handleChangeValue} className="debug-block" />

      </label>

      <AutoComplete input={deferredQuery} language={language} apiKey={apiKey} onSelect={onSelect} />


      <p>
        <a href={`https://www.google.com/maps/search/?api=1&query=${place?.location?.toUrlValue()}&query_place_id=${place?.id}`} target="_blank" rel="noreferrer" ref={linkRef} dangerouslySetInnerHTML={{
        __html: place?.adrFormatAddress ?? ''
      }} />

      </p>
      <div ref={mapRef} className={cn.Map}></div>
    </>;
}
_s6(PlaceIdSelector, "HtAUPQAe2I8KTioF1gStJNHSBrQ=", false, function () {
  return [usePlace, useDeferredValue];
});
_c4 = PlaceIdSelector;
var _c, _c2, _c3, _c4;
$RefreshReg$(_c, "GoogleMapPlaceIdComponent");
$RefreshReg$(_c2, "GoogleMapPlaceIdComponentDialogContent");
$RefreshReg$(_c3, "AutoComplete");
$RefreshReg$(_c4, "PlaceIdSelector");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;